export default __webpack_public_path__ + "static/media/work7.7a15803e.png";